var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 20 .707-.707.707.707-.707.707L26 20Zm0 0-.707.707-9.9-9.9.708-.707.707-.707 9.9 9.9L26 20Zm-9.9 9.9-.707-.708 9.9-9.9L26 20l.707.707-9.9 9.9-.706-.707Z",
    fill: "currentColor"
  })));
};
export default SvgChevron;